const PIN_PASSWORD_PREFIX = 'Bhima!';

export function isValidPin(pin) {
  return /^\d{4}$/.test(pin);
}

export function mapPinToPassword(pin) {
  return `${PIN_PASSWORD_PREFIX}${pin}`;
}
